import L from 'leaflet'
import Splide from "@splidejs/splide"

export function initCategoryPage() {
    const categoryPage = document.querySelector('.categoryPage')
    if (categoryPage) {
        setupCategoryPage(categoryPage)
    }
}

function setupCategoryPage(categoryPage) {

    const markers = [].slice.apply(categoryPage.querySelectorAll('.categoryPage-post-marker')),
        catSlider = categoryPage.querySelector('.categoryPage-terms-slider')

    if (catSlider) {
        initCatSlider()
    }


    let map = L.map(categoryPage.querySelector('.categoryPage-map'), {
        center: [59.756957, 18.697843],
        zoom: parseInt(categoryPage.dataset.mapZoom),
        scrollWheelZoom: false
    })

    L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
        id: 'mapbox/streets-v11',
        tileSize: 512,
        zoomOffset: -1,
        accessToken: 'pk.eyJ1Ijoic3ppbHZlc3p0ZXI5OCIsImEiOiJja25wcDBrZ3oxMGMwMm5sYXpwbjNrMmU0In0.2-tUjeLsDEEyCKlBtx9rmg'
    }).addTo(map)

    map.addEventListener('click', () => {
        map.scrollWheelZoom.enabled() ? map.scrollWheelZoom.disable() : map.scrollWheelZoom.enable()
    })

    if (markers) {
        markers.forEach(marker => {
            L.marker([marker.dataset.lat, marker.dataset.long]).addTo(map).bindPopup(marker.dataset.title)
        })
    }

    function initCatSlider() {
        const isActive = catSlider.querySelectorAll('.splide__slide').length > 6

        let slider = new Splide(catSlider, {
            arrows: isActive,
            drag: isActive,
            pagination: false,
            perPage: 6,
            breakpoints: {
                768: {
                    perPage: 5,
                },

                600: {
                    perPage: 4,
                },

                480: {
                    perPage: 3,
                },

                380: {
                    perPage: 2,
                }
            }
        })

        slider.mount()
    }
}

